import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    font-family: "Nanum Barun Gothic", sans-serif;
  }
  ul,
  ol {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      padding: 0;
      margin: 0;
      outline: none;
      background: none;
    }
  }
  img {
    width: 100%;
    display: block;
    border: 0 none;
  }
  button {
    padding: 0;
    margin: 0;
    outline: none;
    border: none;
    background: none;
    appearance: none;
    -webkit-appearance: none;
  }

  /** scrollbar 스타일 **/
  ::-webkit-scrollbar {
    display: none;
  }
  /*html {
    scrollbar-3dlight-color: #efefef;
    scrollbar-arrow-color: #dfdfdf;
    scrollbar-base-color: #efefef;
    scrollbar-face-color: #dfdfdf;
    scrollbar-track-color: #efefef;
    scrollbar-darkshadow-color: #efefef;
    scrollbar-highlight-color: #efefef;
    scrollbar-shadow-color: #efefef;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    border: 3px solid #f0f0f0;
  }
  ::-webkit-scrollbar-button:start:decrement,
  ::-webkit-scrollbar-button:end:increment {
    display: block;
    height: 10px;
    background: #efefef;
  }
  ::-webkit-scrollbar-track {
    background: #efefef;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    !* -webkit-box-shadow: inset 0 0 4px #f0f0f0*!
  }
  ::-webkit-scrollbar-thumb {
    height: 50px;
    width: 50px;
    background: #cdcdcd;
    -webkit-border-radius: 8px;
    border-radius: 8px;
    !*-webkit-box-shadow: inset 0 0 4px #f0f0f0*!
  }*/
`;

export default GlobalStyle;
